<template>
  <div
    v-on:mouseenter="selectVideo"
    v-on:mouseleave="closeVideo"
    @click="open"
    class="pointer center"
  >
    <div v-show="!play">
      <img v-if="item.video_id != 0" :src="item.image" style="width: 100%;" />
      <img v-if="item.video_id == 0" :src="item.image" class="mt-3" width="120" />
    </div>
    <video v-show="play" ref="video" width="100%" controls controlslist="nodownload">
      <source :src="item.video" />
    </video>
  </div>
</template>

<script>
export default {
  props: ["item", "open"],
  data: () => ({
    play: false,
    mouseEnter: false,
  }),
  mounted() {
    eventBus.$on("stopVideoItem", (field) => {
      this.closeVideo();
      this.mouseEnter = false;
    });
  },
  methods: {
    selectVideo() {
      eventBus.$emit("stopVideoItem", true);
      this.mouseEnter = true;
      setTimeout(() => {
        if (this.mouseEnter) {
          let video = this.$refs["video"];
          this.play = true;
          video.load();
          setTimeout(() => {
            if (this.mouseEnter == true) {
              video.play();
            } else {
              this.play = stop;
              video.pause();
            }
          }, 500);
        }
      }, 1700);
    },
    closeAllVideo() {
      eventBus.$emit("stopVideoItem", true);
    },
    closeVideo() {
      this.mouseEnter = false;
      this.play = false;
      let video = this.$refs["video"];
      if (video) {
        video.pause();
      }
    },
  },
};
</script>
